import {
  buildOrderLiteral,
  buildPagingLiteral,
  buildWhereLiteral,
  OrderBy,
} from '@/lib/graphql-query-builder';

const PM_FORM_FIELDS = `
  ItemId
  CreatedDate
  LastUpdatedDate
  Title
  Description
  AssessmentType
  ReviewType
  Category
  IsAllDepartments
  DepartmentIds
  IsAllDesignations
  DesignationIds
  ConfirmationForIntern
  HasSections
  FormDataJson
  SectionsJson
`;

/** Latest change first by default, like the old `GetPmForms` `{ LastUpdateDate: -1 }` sort. */
export const DEFAULT_PM_FORMS_ORDER: OrderBy[] = [{ field: 'LastUpdatedDate', direction: 'DESC' }];

export const buildGetPmFormsQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number,
  order: OrderBy[] = DEFAULT_PM_FORMS_ORDER
) => `
  query {
    PmForms: getPmForms(
      where: ${buildWhereLiteral(where)}
      order: ${buildOrderLiteral(order)}
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      hasNextPage
      hasPreviousPage
      totalCount
      totalPages
      pageSize
      pageNo
      items {
        ${PM_FORM_FIELDS}
      }
    }
  }
`;
